import React from 'react';
import { PanelLayout } from './panels';

export interface Deck {
  label: string;
  path: string;
}

export interface Widget {
  title: string;
  description: string;
  category: string;
  Component: React.ComponentType;
  layoutDefaults: PanelLayout;
}

const deckTypes: Record<string, Deck> = {
  home: { label: 'Observation Deck', path: '/v4/home' },
  cloud: { label: 'Cloud', path: '/v4/cloud' },
  recon: { label: 'NMS Dashboard', path: '/v4/nms' },
  synthPerformanceDash: { label: 'Synthetics Dashboard', path: '/v4/synthetics/dashboard' }
};

export default deckTypes;
